import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

const PATH = "email-completion";

@Injectable({
  providedIn: 'root'
})
export class EmailCompletionService {

  constructor(private APIService: ApiService) { }

  generatePreview(masterAccountID: number, accountAppID: number, request: any) {
      return this.APIService.post(`${PATH}/${masterAccountID}/${accountAppID}/preview`, request);
  }

}
